import navLinks from './navLinks';
import secondaryNavLinks from './seconaryNavLinks';
/**
 * A custom hook to return the default value for required props of `SignedOutHeader` component
 * @returns {ResponseType} Returns a response of type `ResponseType`
 * @example <caption>`useDefaultProps` can be used without mutating the response</caption>
 * import { SignedOutHeader } from '@chegg-me-components/signed-out-header';
 * import { useDefaultProps } from '@chegg-me-components/signed-out-header-props';
 *
 * const App = () => (
 * <>
 * <SignedOutHeader {...useDefaultProps()} />
 * <RestOfTheApp />
 * </>
 * )
 * @example <caption>`useDefaultProps` can also be used with mutated response as per the needs</caption>
 * import { SignedOutHeader } from '@chegg-me-components/signed-out-header';
 * import { useDefaultProps } from '@chegg-me-components/signed-out-header-props';
 *
 * const App = () => {
 * // mutating the response as per needs and the using is as props
 * const defaultProps = {
 * ...useDefaultProps(),
 * mainContentId: "mainContentId",
 * envUrl: "https://www.chegg.com/"
 * }
 * return (
 * <>
 * <SignedOutHeader {...defaultProps} />
 * <RestOfTheApp />
 * </>
 * )
 * }
 */

var useDefaultProps = function useDefaultProps() {
  return {
    navLinks: navLinks,
    secondaryNavLinks: secondaryNavLinks,
    mainContentId: 'main',
    envUrl: '/',
    children: 'hideSearchOnThisPage'
  };
};

export default useDefaultProps;